import { render, staticRenderFns } from "./BaseTradeInOptionItem.vue?vue&type=template&id=c57d1254&scoped=true"
import script from "./BaseTradeInOptionItem.vue?vue&type=script&lang=js"
export * from "./BaseTradeInOptionItem.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInOptionItem.vue?vue&type=style&index=0&id=c57d1254&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d1254",
  null
  
)

export default component.exports